/**
 * UrlField Component
 *
 * url 타입 필드를 렌더링하는 컴포넌트
 * HTML5 URL 검증을 활용한 shadcn/ui Input 컴포넌트 사용
 */

import { Input } from '@/shared/ui/input';

import type { BaseFieldProps } from './types';

/**
 * URL 입력 필드
 *
 * text 필드와 동일하지만 type="url"로 설정하여
 * HTML5 기본 URL 검증을 활용함
 */
export function UrlField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Input
        id={field.id}
        name={field.name}
        type="url"
        placeholder={field.placeholder}
        disabled={disabled}
        autoComplete="off"
        className="h-12 px-4 py-3"
        onChange={(e) => onChange(e.target.value)}
        value={(value as string) || ''}
        aria-invalid={!!error}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
